<template>
  <path
    d="M19.35 10.0402C18.67 6.59024 15.64 4.00024 12 4.00024C9.11 4.00024 6.6 5.64024 5.35 8.04024C2.34 8.36024 0 10.9102 0 14.0002C0 17.3102 2.69 20.0002 6 20.0002H19C21.76 20.0002 24 17.7602 24 15.0002C24 12.3602 21.95 10.2202 19.35 10.0402ZM10.71 16.2902C10.32 16.6802 9.69 16.6802 9.3 16.2902L7.2 14.2002C6.81 13.8102 6.81 13.1802 7.2 12.7902C7.59 12.4002 8.22 12.4002 8.61 12.7902L10 14.1802L14.48 9.70024C14.87 9.31024 15.5 9.31024 15.89 9.70024C16.28 10.0902 16.28 10.7202 15.89 11.1102L10.71 16.2902Z"
  />
</template>
